import { createFileRoute } from "@tanstack/react-router";

import CustomizeDone from "./-components/CustomizeDone";

export const Route = createFileRoute(
  "/_app/_dashboard/subscription/customize/done"
)({
  component: CustomizeDone,
});
